import { createAction, props } from '@ngrx/store';
import { Page } from '../../models';

export const LoadPages = createAction('[Shopify] Load Pages');
export const LoadPagesSuccess = createAction('[Shopify] Load Pages Success', props<{ pages: any }>());
export const LoadPagesFail = createAction('[Shopify] Load Pages Fail', props<{ error: any }>());

export const LoadPageByHandle = createAction('[Shopify] Load Pages By Handle', props<{ handle: string }>());
export const LoadPageByHandleSuccess = createAction('[Shopify] Load Pages By Handle Success', props<{ page: any }>());
export const LoadPageByHandleFail = createAction('[Shopify] Load Pages By Handle Fail', props<{ error: any }>());
